import { PayrollCalendarFrequencyResponse } from '@/modules/employer/components/SetupEmployer/Features/PayrollCalendar/payrollCalendar.types';
import { PayrollCalendarConfig } from '@/modules/Renewals/renewals.types';

export interface ScheduleDaySummary {
  label: string;
  value: string;
}

const DEFAULT_VALUE = '-';

const capitalize = (value?: string): string =>
  value ? `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}` : DEFAULT_VALUE;

/**
 * Derives the frequency-conditional "schedule day" row (label + display value) for the
 * card, e.g. "Day of week: Friday" or "Days of month: 5, 20".
 */
export const getScheduleDaySummary = (
  rawFrequency?: string,
  config?: PayrollCalendarConfig,
  annualDate?: string
): ScheduleDaySummary => {
  const { firstDayOfMonth, secondDayOfMonth, dayOfMonth, dayOfWeek } = config ?? {};

  if (
    rawFrequency === PayrollCalendarFrequencyResponse.WEEKLY ||
    rawFrequency === PayrollCalendarFrequencyResponse.BI_WEEKLY
  ) {
    return { label: 'Day of week', value: capitalize(dayOfWeek) };
  }

  if (rawFrequency === PayrollCalendarFrequencyResponse.ANNUALLY) {
    return { label: 'Date of year', value: annualDate || DEFAULT_VALUE };
  }

  if (
    rawFrequency === PayrollCalendarFrequencyResponse.SEMI_MONTHLY &&
    firstDayOfMonth !== undefined &&
    secondDayOfMonth !== undefined
  ) {
    return { label: 'Days of month', value: `${firstDayOfMonth}, ${secondDayOfMonth}` };
  }

  return {
    label: 'Day of month',
    value: `${firstDayOfMonth ?? dayOfMonth ?? DEFAULT_VALUE}`,
  };
};

export default getScheduleDaySummary;
